<template>
  <div class="field">
    <div :class="['form-group', { error: validationErrors.length }]">
      <span class="controls">
        <slot name="controls"></slot>
      </span>
      <div v-if="displayLabel" class="field-label">
        <field-label
          :field="field"
          :is-manager="isManager"
          :element-id="elementId"
        />
        <help-icon v-if="field.helpText" :content="field.helpText" />
        <div v-if="displayCounters" class="counters">
          <counters :field="field" :value="value || ''"></counters>
        </div>
      </div>
      <div>
        <slot></slot>
        <validation-errors
          :attribute="attribute"
          :validation-errors="validationErrors"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Container from './Container.vue';

export default {
  extends: Container,
  computed: {
    showLabel() {
      return this.field.type !== 'checkbox';
    }
  }
};
</script>
